<template>
  <div class="score_breakdown">
    <div class="detail-box_operate">
      <div class="operate-filter">
        <div class="operate-filter_label">选择学生:</div>

        <el-select v-model="s_id" placeholder="请选择" @change="handleStudentChange">
          <el-option v-for="item in studentList" :key="item.s_id" :label="item.s_name" :value="item.s_id"> </el-option>
        </el-select>
      </div>

      <el-button type="primary" @click="$router.back()">返回</el-button>
    </div>

    <div class="score_content">
      <div class="score_header">
        <div class="header_left">
          <!-- <i class="el-icon-back" @click="goBack"></i>
          <span class="back_name" @click="goBack">返回</span>
          <span class="line"></span> -->
          <span class="task_name">{{ name }}——得分明细</span>
        </div>
        <div class="hrader_right">
          <div class="image">
            <img v-if="student_avator" :src="student_avator" alt="" />
            <img v-else src="@/assets/images/user_img.png" alt="" />
          </div>
          <div class="student_name">{{ student_name }}</div>
          <div class="score">{{ score }}分</div>
        </div>
      </div>

      <el-table
        :data="scoreDetialData"
        row-key="id"
        ref="questionTableRef"
        :tree-props="{ children: 'children' }"
        :default-expand-all="true"
        style="
          width: 100%; 
          border-radius: 4px;
        "
      >
        <el-table-column prop="class_name" label="一级名称">
          <template slot-scope="scope">
            <div v-if="Number(scope.row.type) == 1">
              {{ scope.row.class_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="topic_title" label="题目" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div
              v-if="Number(scope.row.type) == 2"
              style="width: 100%;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;"
              v-html="scope.row.topic_title"
            ></div>
          </template>
        </el-table-column>
        <el-table-column prop="class_name" label="二级名称">
          <template slot-scope="scope">
            <div v-if="Number(scope.row.type) == 3">
              {{ scope.row.class_name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="topic_title" label="题目" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div
              v-if="Number(scope.row.type) == 4"
              style="width: 100%;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;"
              v-html="scope.row.topic_title"
            ></div>
          </template>
        </el-table-column>
        <el-table-column prop="score" label="回答">
          <template slot-scope="scope">
            <div v-if="Number(scope.row.type) == 2 || Number(scope.row.type) == 4">
              <div v-if="scope.row.topic_type == 1 || scope.row.topic_type == 3">
                <span v-if="scope.row.stu_answer !== ''"> {{ scope.row.topic_options[scope.row.stu_answer].name }}</span>
                <span v-else style="color: #f56c6c;">未作答</span>
              </div>
              <div v-else-if="scope.row.topic_type == 2">
                <div v-if="scope.row.stu_answer.length > 0" style="display: flex;flex-direction: column;">
                  <span v-for="item in scope.row.stu_answer">{{ scope.row.topic_options[item].name }}</span>
                </div>
                <div v-else style="color: #f56c6c;">未作答</div>
              </div>
              <div v-else-if="scope.row.topic_type == 4">
                <div v-if="scope.row.stu_answer.every((item) => item.value === '')" style="color: #f56c6c;">
                  未作答
                </div>
                <div v-else style="display: flex;flex-wrap: wrap;">
                  <span v-for="item in scope.row.stu_answer" style="margin-right: 5px;">{{ item.value }}</span>
                </div>
              </div>
              <div v-else>
                <span v-if="scope.row.stu_answer">{{ scope.row.stu_answer }}</span>
                <span v-else style="color: #f56c6c;">未作答</span>
              </div>
            </div>
            <!-- <div v-if="(Number(scope.row.type) == 2 || Number(scope.row.type) == 4) && (scope.row.topic_type==1 ||scope.row.topic_type==2 || scope.row.topic_type==3)">{{ scope.row.topic_options[stu_answer].name }}</div> -->
          </template>
        </el-table-column>
        <el-table-column prop="score" label="系统判定结果" width="160">
          <template slot-scope="scope">
            <div v-if="Number(scope.row.type) == 2 || Number(scope.row.type) == 4">
              <!-- <span v-if="scope.row.topic_type!=5">{{ scope.row.is_true }}</span> -->
              <div v-if="scope.row.topic_type != 5">
                <span
                  v-if="scope.row.is_true == 1"
                  style="color: #67c23a;background: #f0f9eb; border: 1px solid #e1f3d8; border-radius: 4px;padding: 3px 6px;font-size: 12px;"
                  >正确</span
                >
                <span
                  v-if="scope.row.is_true == 0"
                  style="color: #f56c6c;background: #fef0f0; border: 1px solid #fde2e2; border-radius: 4px;padding: 3px 6px;font-size: 12px;"
                  >错误</span
                >
              </div>
              <div v-else>
                <span
                  style="color: #909399;background: #f4f4f5; border: 1px solid #e9e9eb; border-radius: 4px;padding: 3px 6px;font-size: 12px;"
                  >教师评分</span
                >
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="score" label="分值" width="120" align="center">
          <template slot-scope="scope">
            <div v-if="role == 3">
              <div v-if="Number(scope.row.type) == 2 || Number(scope.row.type) == 4" style="width: 100%;">
                <div v-if="scope.row.topic_type != 5" style="width: 100%;display: flex;align-items: center;justify-content: center;">
                  {{ scope.row.stu_score }}
                </div>
                <div v-else>
                  <span>{{ scope.row.stu_score || 0 }}</span>
                </div>
              </div>
            </div>
            <div v-else>{{ teacher_status == 0 && scope.row.topic_type == 5 ? "暂未评分" : scope.row.stu_score }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      studentList: [],
      scoreDetialData: [],
      student_name: "",
      student_avator: "",
      score: 0,
      role: 0,
      s_id: 0,
      teacher_status: 0,
      name: "",
    };
  },
  components: {
    //     jdTrainingGetStuTopicDetail:"jd/training/getStuTopicDetail",
    // jdTrainingTeacherScore:"jd/training/TeacherScore",
    // jdTrainingRepeat:"jd/training/repeat",
    // jdTrainingTeacherScoreNextStuId:
  },
  created() {
    this.s_id = this.$route.query.s_id;
    this.getStudentList();

    this.role = localStorage.getItem("role");
    this.getStudentScoreDetial();
  },
  computed: {},
  watch: {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getStudentList() {
      // showStudent
      const params = {
        type: "all",
        c_id: Number(this.$route.query.class_id),
        s_id: Number(this.$route.query.s_id),
      };

      this.$shttp.axiosGetBy(this.$api.showStudent, params, (res) => {
        if (res.code === 200) {
          this.studentList = res.data;
        }
      });
    },

    getStudentScoreDetial() {
      let params = {
        project_id: this.$route.query.project_id,
        course_id: this.$route.query.course_id,
        course_chapter: this.$route.query.zhangIndex,
        course_node: this.$route.query.jieIndex,
        c_id: this.$route.query.class_id,
        s_id: this.s_id,
        type: 0,
      };
      this.$shttp.axiosGetBy(
        this.$api.jdTrainingGetStuTopicDetail,
        params,
        (res) => {
          if (res.code === 200) {
            if (this.role == 3 && res.data.teacher_status == 0) {
              res.data.topic_data.forEach((item) => {
                item.children.forEach((item1) => {
                  if (Number(item1.type) == 2) {
                    if (item1.topic_type == 5 && item1.stu_score == 0) {
                      item1.stu_score = void 0;
                    }
                  }
                  if (Number(item1.type) == 3) {
                    item1.children.forEach((item3) => {
                      if (item3.topic_type == 5 && item3.stu_score == 0) {
                        item3.stu_score = void 0;
                      }
                    });
                  }
                });
              });
            }
            this.scoreDetialData = res.data.topic_data;
            this.student_avator = res.data.s_ico ? res.data.s_ico : "";
            this.student_name = res.data.s_name;
            this.score = res.data.score;
            this.teacher_status = res.data.teacher_status;
            this.name = res.data.project_title;
          } else {
            this.scoreDetialData = [];
          }
        },
        (err) => {
          console.log(err);
        },
      );
    },

    handleStudentChange(s_id) {
      this.s_id = s_id;

      this.getStudentScoreDetial();
    },
  },
};
</script>

<style scoped lang="scss">
.score_breakdown {
  width: 100%;
  height: calc(100vh - 70px);
  // background-color: #ffffff;
  background: #eff3fd;
  padding: 20px 30px;
  box-sizing: border-box;
  overflow-y: auto;

  .detail-box_header {
    height: 24px;
    font-family: PingFang-SC, PingFang-SC;
    font-weight: 800;
    font-size: 24px;
    color: #333333;
    line-height: 24px;
  }

  .detail-box_operate {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;

    .operate-filter {
      display: flex;
      align-items: center;
      gap: 20px;

      &_label {
        height: 30px;
        font-family: PingFang-SC, PingFang-SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 30px;
      }
    }

    .el-button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 88px;
      height: 36px;
    }
  }

  .score_content {
    margin-top: 20px;
    width: 100%;
    // height: 100%;
    // border: 1px solid #ebeef5;
    // box-shadow: 0 5px 10px 1px rgba(32, 32, 32, 0.05);
    padding: 20px;
    box-sizing: border-box;
    background: #fff;

    .score_header {
      align-items: center;
      display: flex;
      justify-content: space-between;
      line-height: 24px;
      padding-bottom: 20px;
      border-bottom: 1px solid #e4e7ed;

      .header_left {
        display: flex;
        align-items: center;

        .el-icon-back {
          color: #323335;
          cursor: pointer;
        }

        .back_name {
          color: #303133;
          font-size: 14px;
          margin: 0 10px;
          cursor: pointer;
        }

        .line {
          border-left: 1px solid #dcdfe6;
          display: inline-block;
          height: 1em;
          margin: 0 8px;
          position: relative;
          vertical-align: middle;
          width: 1px;
        }

        .task_name {
          color: #303133;
          font-size: 18px;
          font-weight: 600;
        }
      }

      .hrader_right {
        display: flex;
        align-items: center;

        .image {
          width: 30px;
          height: 30px;
          border-radius: 50%;

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            object-fit: cover;
          }
        }

        .student_name {
          color: #4b5563;
          font-size: 16px;
          margin: 0 10px;
        }

        .score {
          color: #dc2626;
          font-size: 16px;
        }
      }
    }
  }
}

.footer_button {
  display: flex;
  height: 100px;
  align-items: center;
  justify-content: center;

  .el-button {
    width: 140px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

::v-deep .el-table .cell {
  display: flex;
  align-items: center;
}

/* 设置滚动条整体 */
::-webkit-scrollbar {
  width: 3px;
  /* 滚动条宽度 */
  height: 6px;
  /* 水平滚动条高度 */
}

/* 设置滚动条轨道 */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* 轨道背景色 */
}

/* 设置滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #d3d2d2;
  /* 滑块背景色 */
  border-radius: 6px;
  /* 滑块圆角 */
}

/* 设置滚动条滑块悬停时的样式 */
::-webkit-scrollbar-thumb:hover {
  background: #555;
  /* 滑块悬停背景色 */
}
</style>
